<script>
	// @ts-nocheck

	import fedp from '$lib/images/fedp.svg';
	import fedn from '$lib/images/fedn.svg';
	import { fade, slide, fly } from 'svelte/transition';
	import { env as public_env } from '$env/dynamic/public';
	import { onMount, onDestroy } from 'svelte';
	import { variables } from '$lib/variables';
	import prev from '$lib/images/rig.svg';
	import loader from '$lib/images/loader.svg';
	import next from '$lib/images/left.svg';
	import { goto } from '$app/navigation';
	export let items, hoverActive, link, reload, product;

	let currentSlide = 1;
	let totalSlides = items.length;
	let swiper;
	// Генерируем случайный класс заданной длины, например, 10 символов

	let load = true;
	let videoElement;
	let isVideoVisible = false;

	// Функция для запуска видео
	function playVideo() {
		if (videoElement && isVideoVisible) {
			videoElement.play();
		}
	}
	if (items.length > 0) {
		items.forEach((item) => {
			if (item.image_thumbnail === null || !item.image_thumbnail.startsWith('https')) {
				item.image_thumbnail = `https://e2c81946-360a-4c6f-9dcf-dbcfe7335e1a.selstorage.ru${item.image_thumbnail.replace('/media', '')}`;
			}
		});
	}

	// Инициализация IntersectionObserver для проверки видимости
	onMount(() => {
		console.log('items', items);
		
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						isVideoVisible = true;
						playVideo(); // Запускаем видео, если оно в области видимости
					}
				});
			},
			{ threshold: 0.5 } // Видео должно быть хотя бы на 50% в области видимости
		);

		if (videoElement) {
			observer.observe(videoElement);
		}

		return () => {
			observer.disconnect();
		};
	});
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
	style="overflow: hidden;position: relative;max-height: 336px;"
	class=" {reload ? 'additional-class2' : 'additional-class'}"
>
	<!-- Additional required wrapper -->
	<div class="swiper-wrapper">
		<!-- Slides -->

		<!-- svelte-ignore missing-declaration -->
		<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
		<!-- svelte-ignore a11y-click-events-have-key-events -->
		{#if !product.link_video_card}
			<img
				on:click={() => {
					if (!reload) {
						goto(link);
					} else {
						location.href = link;
					}
				}}
				style="width: 100%;height: auto;"
				src="{items[0].image_thumbnail}"
				alt=""
				loading="lazy"
			/>
		{:else}
			<!-- Отображаем видео, если ссылка на видео существует -->
			<!-- <video 
			bind:this={videoElement}
			style="width: auto; height: 100%;"
			muted
			preload="auto"
			controls
			loop 
		  >
			<source src="{product.link_video_card}" type="video/mp4" />
			Ваш браузер не поддерживает видео.
		  </video> -->
			<video
				bind:this={videoElement}
				style="width: 100%; height: auto;"
				muted
				preload="auto"
				playsinline
				disablepictureinpicture
				controlslist="nodownload noplaybackrate"
			>
				<source src={product.link_video_card} type="video/mp4" />
				Ваш браузер не поддерживает видео.
			</video>
		{/if}
		<!-- If we need pagination -->
	</div>

	<!-- If we need scrollbar -->
	<div class="swiper-scrollbar hidden" />
	<div
		style=""
		class="swiper-pagination md:hidden block"
		on:click|stopPropagation|preventDefault={() => {}}
	/>
</div>
<div>
	<div class="left-0 w-full absolute top-[45%] z-50 mt-10">
		<div class="flex relative justify-between items-center">
			<!-- Навигационные кнопки -->
			<!-- svelte-ignore a11y-click-events-have-key-events -->
			<!-- svelte-ignore a11y-no-static-element-interactions -->
			<div
				on:click|stopPropagation|preventDefault={() => {}}
				class="swiper-button-prevfed2 absolute -left-6 hidden md:block"
			/>

			<!-- svelte-ignore a11y-click-events-have-key-events -->
			<!-- svelte-ignore a11y-no-static-element-interactions -->
			<div
				on:click|stopPropagation|preventDefault={() => {}}
				class="swiper-button-nextfed2 absolute -right-6 hidden md:block"
			/>
		</div>
	</div>
</div>

<style>
	.additional-class2 {
		max-width: 300px;
	}

	@media (max-width: 1000px) {
		.additional-class2 {
			max-width: 215px;
		}
	}
	.additional-class {
		max-width: 300px;
	}
	@media (max-width: 1000px) {
		.additional-class {
			max-width: 200px;
		}
	}
	@media (max-width: 600px) {
		.additional-class {
			max-width: 150px;
		}
	}
	.swiper-slide {
		display: flex;
		justify-content: center; /* Центрирует содержимое по горизонтали */
		align-items: center; /* Центрирует содержимое по вертикали */
		width: 100%;
		max-width: 100%;
	}

	.swiper-button-prevfed2 {
		margin-left: 3%;
		position: relative;
	}
	.swiper-button-nextfed2 {
		margin-right: 3%;
		position: relative;
	}
	.swiper-button-nextfed2::after {
		display: none;
	}
	.swiper-button-prevfed2::after {
		display: none;
	}
	/* .swiper-pagination {
		bottom: -12px;
	} */
	/* Стиль для активного буллета */
	.swiper-pagination-bullet-active {
		background: black; /* Устанавливаем черный цвет */
	}
</style>
